// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listItem_JrFf7 {
  cursor: pointer;
}

.listItem_JrFf7:hover {
  background-color: var(--color-background-hover);
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/views/TagPairingValidation/TagPairingSelectionRenderer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".listItem {\n  cursor: pointer;\n}\n\n.listItem:hover {\n  background-color: var(--color-background-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": `listItem_JrFf7`
};
export default ___CSS_LOADER_EXPORT___;
